
<template>
    <div class="attachments" v-if="attachmentCount(item)">
        <template v-if="attachmentsList.length">
            <button v-for="attachment in attachmentsList"
                    type="button"
                    class="btn nobg attachment"
                    @click.prevent="handleClick(attachment)"
            >
                <Icon name="paperclip" />
                <span class="title">{{ attachment.data.filename }}</span>
            </button>
        </template>
        <template v-else>
            <button v-for="index in attachmentCount(item)"
                    type="button"
                    class="btn nobg attachment"
            >
                <Icon name="paperclip" />
                <span class="title">{{ trans('Bezig met laden...') }}</span>
            </button>
        </template>
    </div>
</template>

<script>
import {defineComponent, onMounted, computed, inject, ref} from "vue";

// Config for API urls used in this vue template
import trans from "helpers/_translation";
import { attachments, attachmentCount } from "helpers/_inbox-helpers";

import Icon from "components/icon";

export default defineComponent({
    name: "inbox-attachments",
    components: {
        Icon
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    },
    setup(props) {
        const addNotification = inject("addNotification");
        const item = computed(() => {
            return props.item;
        });
        const attachmentsList = ref([]);
        const fetchAttachments = async () => {
            try {
                const data = await attachments(props.item);
                attachmentsList.value = data.data;
            } catch (error) {
                console.error('Error fetching attachments:', error);
            }
        };

        onMounted(fetchAttachments);

        const handleClick = (attachment) => {
            const filePath = attachment._links?.downloadurl?.href;
            if (!filePath) {
                addNotification(trans("Bestand kon niet worden gevonden") + "...", 3500);
                return;
            }
            // Download file based on attachment._links.filepath.href
            window.open(attachment._links?.downloadurl?.href, '_blank');
        };

        return {
            trans,
            attachmentsList,
            attachmentCount,

            handleClick
        }
    }
});

</script>
